export default {
  ORDER_CLAIMED: 'order_claimed',
  ORDER_CALL: 'order_call',
  ORDER_UPDATED: 'order_updated',
  PAYMENT_REMINDER_CALL: 'payment_reminder_call',
  PAYMENT_REMINDER_UPDATE: 'payment_reminder_update',
  CONTRACT_APPROVED: 'contract_approved',
  CONTRACT_CANCELED: 'contract_canceled'
};
